module.exports = __webpack_public_path__ + "static/media/large_marni-green-asymmetrical-earrings-with-strass-in-green_thumb.a21b3e63.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/jewellery/large_marni-green-asymmetrical-earrings-with-strass-in-green_thumb.png
// module id = 250
// module chunks = 0